import { defineEffect } from '../../../core/effect';
import { summonPanel } from '../fx/summonPanel';

/**
 * **反転召喚成功（ステータスのパネル）**（Issue #581 v1。指示書 `../direction/flipsummoning.md`）。
 * 通常召喚の成功（`summoned.js`）と同じ絵（`../fx/summonPanel.js`）。どのカードかは port が付ける `payload.summon`
 * （同じフェイズの直前の `flipsummoning`。`editorPorts/duelEffects.js::duelPayloads`）。
 */
export default defineEffect(summonPanel({
  situation: 'flipsummoned',
  role: 'effect',
  label: '反転召喚成功（ステータスのパネル）',
  color: '#ffc21a',
}), 'flipsummoned_effect.js');
